export default __webpack_public_path__ + "static/media/LearningStrategistIcon.724f1390.svg";